import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'WhatsApp',
  subtitle: 'Marketing',
  tagline: 'Direct & Personal Communication',
  icon: '',
  // icon: '💬',

  heroDesc: 'Reach your customers where they\'re most active. WhatsApp marketing delivers your message directly to thousands of customers with industry-leading open rates of 98%.',
  mainStat: '98%',
  mainStatLabel: 'Average open rate for WhatsApp messages',
  subStats: [{ value: '10x', label: 'Higher Engagement vs Email' }, { value: '5min', label: 'Avg Response Time' }],
  features: [
    { icon: '📤', title: 'Bulk Messaging', desc: 'Send personalized messages to thousands of customers simultaneously.' },
    { icon: '🤖', title: 'WhatsApp Business Setup', desc: 'Professional business profile with automated greetings and quick replies.' },
    { icon: '📊', title: 'Campaign Management', desc: 'End-to-end management of promotional and transactional campaigns.' },
    { icon: '🎯', title: 'Audience Segmentation', desc: 'Target specific customer groups with tailored messages.' },
    { icon: '📸', title: 'Rich Media Campaigns', desc: 'Send images, videos, PDFs, and catalogs to showcase your offerings.' },
    { icon: '📈', title: 'Performance Tracking', desc: 'Detailed delivery, open, and click-through rate reporting.' },
  ],
  benefits: [
    { title: 'Instant Customer Reach', desc: 'Messages delivered instantly to your customers\' pockets.' },
    { title: 'High Open Rates', desc: '98% open rate vs 20% for email — your message always gets seen.' },
    { title: 'Two-Way Communication', desc: 'Engage in real conversations that build genuine customer relationships.' },
    { title: 'Cost-Effective Marketing', desc: 'Reach thousands of customers at a fraction of traditional advertising costs.' },
  ],
  process: [
    { title: 'Setup & Configuration', desc: 'WhatsApp Business account setup with professional branding and automated responses.' },
    { title: 'Contact List Building', desc: 'We help you build a compliant, opted-in contact database.' },
    { title: 'Campaign Design', desc: 'Create compelling message templates with media that drives action.' },
    { title: 'Campaign Execution', desc: 'Messages sent at optimal times for maximum response rates.' },
    { title: 'Report & Optimize', desc: 'Analyze results and refine future campaigns for better performance.' },
  ],
  whyChoose: [
    { icon: '✅', title: 'Compliant Campaigns', desc: 'All campaigns follow WhatsApp\'s terms of service and opt-in rules.' },
    { icon: '💬', title: 'Personalization', desc: 'Dynamic message personalization with customer names and preferences.' },
    { icon: '⚡', title: 'Quick Turnaround', desc: 'Campaigns can be launched within 24–48 hours of approval.' },
    { icon: '📊', title: 'Clear Reporting', desc: 'Transparent analytics showing exactly how your campaigns performed.' },
  ],
  reviews: [
    { name: 'Deepak Mehta', role: 'Travel Agency', text: 'Our WhatsApp campaigns get 90%+ open rates. Nothing else comes close for customer communication.' },
    { name: 'Sunita Rao', role: 'Salon Owner', text: 'DMS set up our entire WhatsApp marketing system and it has transformed how we communicate with clients.' },
    { name: 'Rohan Verma', role: 'Coaching Institute', text: 'We now fill our courses through WhatsApp campaigns alone. The ROI is incredible.' },
  ],
  faq: [
    { q: 'Is WhatsApp marketing legal?', a: 'Yes, when done properly through opted-in contacts via WhatsApp Business API. We ensure full compliance.' },
    { q: 'How many people can I reach?', a: 'With WhatsApp Business API, you can reach unlimited opted-in contacts with personalized messages.' },
    { q: 'Can I send images and videos?', a: 'Absolutely! WhatsApp supports text, images, videos, PDFs, location, and product catalogs.' },
  ],
};

export default function WhatsappMarketing() {
  return <ServiceTemplate data={data} />;
}
